var map = {
	"./Fernbedienungsloop.mp4": 4539,
	"./Idle mit FB mit Fish.mp4": 5221,
	"./Idle mit fish und FB.mp4": 9877,
	"./Idle ohne FB mit Fish.mp4": 6054,
	"./Idle ohne FB ohne Fisch.mp4": 5141,
	"./Idle ohne FB ohne Fish.mp4": 7276,
	"./Ludwig FB-Animation Teil 1.mp4": 4745,
	"./Ludwig FB-Animation Teil 2.mp4": 2927,
	"./Ludwig Fernbedienung nehmen.mp4": 3342,
	"./Ludwig Idle links.mp4": 3458,
	"./Ludwig Idle.mp4": 4801,
	"./Ludwig Ludwig von Fernbedienung zurück.mp4": 4247,
	"./Ludwig herein links.mp4": 3391,
	"./Ludwig links ab.mp4": 2993,
	"./Ludwig vom Fish nach links.mp4": 1804,
	"./Ludwig zum Fish.mp4": 6783,
	"./Proof_Concept_Fullscreen.mp4": 3038,
	"./Proof_Concept_Rechts.mp4": 7290,
	"./game_over.mp4": 9829,
	"./linker_simon.mp4": 5914,
	"./off.mp4": 1127,
	"./rick.mp4": 2475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2355;